module.exports = __webpack_public_path__ + "static/media/icons.c4092ae7.svg";